import GullLayout from "app/GullLayout/GullLayout";
import { AppContext } from "app/appContext";
import { restoreSession } from "app/services/AuthService";

import React, { useState, useEffect } from "react";
import { useContext } from "react";
import { memo } from "react";

import { Outlet,  useLocation, useNavigate } from "react-router-dom";

const AuthGuard = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [previouseRoute, setPreviousRoute] = useState(null);
  const context = useContext(AppContext);

  const styles = {
    position: "fixed",
    left: 0,
    right: 0,
    top: "calc(50% - 20px)",
    margin: "auto",
    height: "40px",
    width: "40px",
    zIndex: 324324324,
  };

  useEffect(() => {
    if (previouseRoute !== null) setPreviousRoute(pathname);

    if (!sessionStorage.getItem("jwt_token")) {
      navigate("/signin");
    } else {
      if (Object.keys(context.user).length === 0) {
        restoreSession(context);
      }
    }
  }, [context, navigate, pathname, previouseRoute]);

  return context.user?.role ? (
    <GullLayout>
      <Outlet />
    </GullLayout>
  ) : (
    <div style={styles}>
      <div className="spinner spinner-bubble spinner-bubble-primary"></div>
    </div>
  );
};

export default memo(AuthGuard);
